import { Grid } from "@mui/material"
import MyTable, { TableRow } from "../../../components/MyTable";

import { TableHeadRows } from "../../../components/MyTable/TableHead";
import DownloadButtonDocument from "../../my-potal/documents/downloadButtonDocument";
import { CONTRACT_DOCUMENT_SIGNATURE_REQUEST } from "../../../constants/signalRequestConsts";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { InMyChargeEmployeeContractsRequestId } from "../../../store/slices/userRequests";



interface TableEmployeesContractsProps {
    rucEmpresa?: string;
    // hiddenFilterOptions?: boolean;
    requestId: InMyChargeEmployeeContractsRequestId,
    description: string;
    setDescription: (desc: string) => void;
    pageSize: number;
    setPageSize: (page: number) => void;
    page: number;
    setPage: (page: number) => void;
}

const TableEmployeesContracts = ({
    requestId, 
    description,
    setDescription,
    pageSize,
    setPageSize,
    page,
    setPage,
}: TableEmployeesContractsProps) => {

    const {contracts, totalItems} = useSelector((state: RootState) => state.userRequests)[requestId];
    
    const tableHeadRows = [
        {
            label: "Colaborador",
            rowKeyName: "Descripcion",
        },{
            label: "Empresa",
            rowKeyName: "Empresa",
            allowOrderAction: true,
        },{
            label: "Número",
            rowKeyName: "NumeroContrato",
            allowOrderAction: true,
        },{
            label: "Fecha de inicio",
            rowKeyName: "FechaInicio",
            allowOrderAction: true,
        },{
            label: "Días finalizar",
            rowKeyName: "DiasVencimiento",
            allowOrderAction: true,
        },{
            label: "Tipo contrato",
            rowKeyName: "TipoContrato",
            allowOrderAction: true,
        },{
            label: "Oficina",
            rowKeyName: "Area",
            allowOrderAction: true,
        },{
            label: "Estado",
            rowKeyName: "EstadoAceptacion",
            allowOrderAction: true,
        },{
            label: "Fec. envío",
            rowKeyName: "FechaEnviadoPortal",
            allowOrderAction: true,
        },{
            label: "Fec. firma",
            rowKeyName: "FirmadoFecha",
            allowOrderAction: true,
        },{
            label: "Observación",
            rowKeyName: "FirmadoRespuesta",
            customValue: (headRow: TableHeadRows, row: TableRow<string, any>) => {
                return <Grid
                    container 
                    justifyContent="space-between" 
                    direction="row"
                    style={{minWidth: row.FirmadoRespuesta ? "11rem" : "7rem"}}
                >
                    <Grid 
                        item 
                        style={{
                            width: row.FirmadoRespuesta ? "9rem" : "3rem", 
                            // whiteSpace: "nowrap", 
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            lineClamp: "2",


                            display: "-webkit-box",
                            WebkitLineClamp: 3,
                            WebkitBoxOrient: "vertical",


                        }}>
                        {row.FirmadoRespuesta}
                    </Grid>
                    {/* <Grid item alignItems="flex-end">
                        <IconButton
                            size="small"
                            onClick={() => {
                                setObservation(row.FirmadoRespuesta || "")
                                setContractToObservate(row)
                            }}
                        >
                            <EditNoteIcon fontSize="small" />
                        </IconButton>
                    </Grid> */}
                </Grid>
            }
        },{
            label: "",
            rowKeyName: "viewFile",
            customValue: (headRow: TableHeadRows, row: TableRow<string, any>) => {
                return (
                <DownloadButtonDocument
                    signButton={false}
                    FirmaTop={row.FirmaTop}
                    FirmaLeft={row.FirmaLeft}
                    FirmaPagePosition={row.FirmaPagina}
                    NroFs={row.NroFS}
                    FirmadoFecha={row.FirmadoFecha} 
                    IdDocument={row.NroIdentificadorContrato}
                    requestId={CONTRACT_DOCUMENT_SIGNATURE_REQUEST}
                    signDisabled={true}
                    
                />
            )},
        }
    ]

    return  (
        <>
        <MyTable
            key="tab-0"
            pageNumber={page}
            itemsPerPage={pageSize}
            totalItems={totalItems}
            totalPages={totalItems / pageSize}
            searchInputString={description}
            onChangePageNumber={setPage}
            onChangeItemsPerPage={setPageSize}
            onChangeSearchInputString={setDescription}
            hiddenSearchInput={false}
            tableHeadRows={tableHeadRows}
            // hiddenFilterOptions={hiddenFilterOptions}
            tableRows={contracts}
            loading={false}
            tableOptionsBar={{
                useDrawer: true,
            }}
        />
        </>
    )
}

export default TableEmployeesContracts